import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class FiltersService {

    private filtersSource: Subject<Array<any>> = new Subject();
    filters = this.filtersSource.asObservable();

    private activeViewSource: Subject<String> = new Subject();
    view = this.activeViewSource.asObservable();

    constructor(private http: HttpClient, private constantes: ConstantesService) { }

    getFilters(params: any): Observable<any> {
        let queryParams = '';

        if (params) {
            const serialize = (params = {}) => Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
            queryParams = `?${serialize(params)}`
        }

        return this.http.get(environment.urlBase + 'filters' + queryParams, this.constantes.httpOptions);
    }

    send(filters: Array<any>) {
        this.filtersSource.next(filters)
    }

    activate(view: string) {
        this.activeViewSource.next(view)
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/filters/filters.service.ts